import Masked from 'imask/esm/masked/base';
import { FactoryOpts } from 'imask/esm/masked/factory';

export const OFFERS_LIMIT = 1000;

export const SECOND = 1000;

export const MAX_COUNT_TO_SHOW = 10;

export enum Time {
  Second = 1000,
  Minute = 60 * 1000,
  Hour = 60 * 60 * 1000,
  Day = 24 * 60 * 60 * 1000,
}

export enum UI_BOTTOM_COMPONENTS {
  NAVBAR = 'mobile-navbar',
  CTA = 'mobile-cta',
}

export const PHONE_INPUT_MASK_DATA: ((Masked | FactoryOpts) & {
  startsWith: string;
})[] = [
  {
    mask: '+00 (0000) 000-000',
    startsWith: '44',
    lazy: false,
  },
  {
    mask: '+0 (000) 000-00-00',
    startsWith: '7',
    lazy: false,
  },
  {
    mask: '+000 (00) 000 0000',
    startsWith: '971',
    lazy: false,
  },
  {
    mask: '+0000000000[00000]',
    startsWith: '',
  },
];
